<template>
  <section>
    <div class="table-responsive">
      <table
        class="table p-0 m-0 dataTable text-nowrap"
        :class="orders.length > 1 ? 'min-h-[190px]' : 'min-h-[300px]'"
      >
        <thead class="bg-white">
          <tr class="py-[5px]">
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Order Date
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Order Number
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Channel
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Customer
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Total
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Delivery Status
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Actions
            </th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <tr v-if="loading">
            <td colspan="12" class="text-center">
              <div
                class="text-center"
                style="padding-top: 100px; padding-bottom: 50px"
              >
                <span
                  class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                  style="font-size: 8rem"
                ></span>
                <h3
                  class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                  style="padding-bottom: 100px"
                >
                  Please wait while we load the list
                </h3>
              </div>
            </td>
          </tr>
          <tr v-for="o in orders" :key="o.id" v-else>
            <td
              class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
            >
              {{ formatDate(o.orderDate) }}
            </td>
            <td class="text-[#2463EB] font-medium text-[14px] leading-[20px]">
              {{ o.orderNumber }}
            </td>
            <td
              class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
            >
              {{ o.source }}
            </td>
            <td
              class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
            >
              {{ o.maker.displayName }}
            </td>
            <td
              class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
            >
              &#8358; {{ formatMoney(o.total) }}
            </td>
            <td>
              <button
                :class="[
                  'badge',

                  {
                    'badge-warning': o.status == 'Pending',
                  },
                  {
                    'badge-success':
                      o.status == 'Confirmed' || 'markAsDelivered',
                  },
                  {
                    'badge-info': o.status == 'Dispatched',
                  },

                  {
                    'badge-primary': o.status == 'recallDelivery',
                  },
                ]"
              >
                <span
                  class="inline-block w-[10px] h-[10px] rounded-[1px]"
                  :style="{
                    backgroundColor:
                      o.status === 'Pending'
                        ? '#FFA500'
                        : o.status === 'Confirmed' || 'markAsDelivered'
                        ? '#16a249'
                        : o.status === 'Dispatched'
                        ? '#17A2B8'
                        : o.status === 'recallDelivery'
                        ? '#007BFF'
                        : '#E42728',
                  }"
                ></span>

                {{ o.status }}
              </button>
            </td>
            <td>
              <div class="dropdown">
                <button
                  class="btn-no-border"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span
                    class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none"
                  >
                    ...
                  </span>
                </button>
                <ul
                  class="dropdown-menu shadow-none"
                  aria-labelledby="dropdownMenuButton"
                >
                  <li
                    v-for="(item, index) in filteredMenuItems(o)"
                    :key="index"
                    :class="[
                      'text-[14px] font-normal text-[#353535] cursor-pointer py-[8px] px-[16px]',
                      {
                        'border-b': index !== filteredMenuItems(o).length - 1,
                      },
                    ]"
                    :style="item.style"
                    @click.prevent="item.action"
                  >
                    {{ item.label }}
                  </li>
                </ul>
              </div>
            </td>
          </tr>
          <tr v-if="!orders.length && !loading">
            <td colspan="10">
              <div class="text-center" style="padding-top: 50px">
                <span style="font-size: 4.615rem" class="mdi mdi-basket"></span>
              </div>
              <h3 class="text-center" style="padding-bottom: 100px">
                You have not recieved any orders.
              </h3>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- send invoice modal -->
    <div class="modal fade py-1 z-[11111]" id="mod-send-invoice" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div
            class="modal-header bg-transparent flex items-start justify-between p-0 m-0"
          >
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[10px]"
            >
              Send Invoice
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div v-if="systemSettings.sendManualInvoiceViaSms">
              <div class="flex gap-[5px] items-center">
                <input
                  class="custom-checkbox"
                  type="checkbox"
                  id="sms"
                  v-model="sendInvoice.sendViaSms"
                  :disabled="receiverHasPhoneNumber"
                />
                <label
                  for="sms"
                  class="text-[16px] pt-[7px] leading-[30px] font-normal text-[#353535] cursor-pointer"
                  >Send Invoice Via SMS</label
                >
              </div>
              <small v-if="receiverHasPhoneNumber" class="form-text text-muted"
                >Reciever doesn't have a phone number</small
              >
            </div>
            <div v-if="systemSettings.sendManualInvoiceViaEmail">
              <div class="flex gap-[5px] items-center">
                <input
                  class="custom-checkbox"
                  type="checkbox"
                  id="email"
                  v-model="sendInvoice.sendViaEmail"
                  :disabled="receiverHasEmail"
                />
                <label
                  for="email"
                  class="text-[16px] pt-[7px] leading-[30px] font-normal text-[#353535] cursor-pointer"
                  >Send Invoice Via Email</label
                >
              </div>
              <small v-if="receiverHasEmail" class="form-text text-muted"
                >Reciever doesn't have an email address</small
              >
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="sendInvoiceForOrder"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Send</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- send receipt modal -->
    <div class="modal fade py-1 z-[11111]" id="mod-send-receipt" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div
            class="modal-header bg-transparent flex items-start justify-between p-0 m-0"
          >
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[10px]"
            >
              Send Receipt
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div v-if="systemSettings.sendManualInvoiceViaSms">
              <div class="flex gap-[5px] items-center">
                <input
                  class="custom-checkbox"
                  type="checkbox"
                  id="smsReceipt"
                  v-model="sendReceipt.sendViaSms"
                  :disabled="receiverHasPhoneNumber"
                />
                <label
                  for="smsReceipt"
                  class="text-[16px] pt-[7px] leading-[30px] font-normal text-[#353535] cursor-pointer"
                  >Send Receipt Via SMS</label
                >
                <small
                  v-if="receiverHasPhoneNumber"
                  class="form-text text-muted"
                  >Reciever doesn't have a phone number</small
                >
              </div>
            </div>
            <div v-if="systemSettings.sendManualInvoiceViaEmail">
              <div class="flex gap-[5px] items-center">
                <input
                  class="custom-checkbox"
                  type="checkbox"
                  v-model="sendReceipt.sendViaEmail"
                  :disabled="receiverHasEmail"
                />
                <label
                  for="email"
                  class="text-[16px] pt-[7px] leading-[30px] font-normal text-[#353535] cursor-pointer"
                  >Send Receipt Via Email</label
                >
                <small v-if="receiverHasEmail" class="form-text text-muted"
                  >Reciever doesn't have an email address</small
                >
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="sendReceiptForOrder"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Send</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <ModalOrder
      :order="order"
      :activeTab="activeTab"
      :closeModal="closeModal"
      :switchTab="switchTab"
      v-if="isModalVisible"
      :systemSettings="systemSettings"
      :printPOSInvoice="printPOSInvoice"
      :printA4Invoice="printA4Invoice"
      :viewSendInvoice="viewSendInvoice"
      :actionsList="actionsList"
      :viewSendReceipt="viewSendReceipt"
      :printReceipt="printReceipt"
      :posReceipt="posReceipt"
    />
    <div
      id="printReceipt"
      style="display: none"
      class="card-body bg-white text-dark"
    >
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="invoice-title">
              <div class="row">
                <div class="col-md-4 text-center alert alert-success">
                  <h4>RECEIPT</h4>
                  <h1>{{ order.seller ? order.seller.name : "NA" }}</h1>
                </div>
                <div class="col-md-8 text-right">
                  <strong>
                    {{ order.seller ? order.seller.name : "NA" }}
                  </strong>
                  <address>
                    <strong>Date: {{ formatDate(order.created) }}</strong
                    ><br />
                    <strong>RN: {{ order.orderNumber }}</strong>
                  </address>
                </div>
              </div>
              <hr />
            </div>
            <div class="row">
              <div class="col-md-6">
                <address>
                  <strong>Customer Details:</strong><br />
                  {{ order.maker ? order.maker.displayName : "" }}<br />
                  {{
                    order.maker
                      ? order.maker.phoneNumber
                        ? order.maker.phoneNumber
                        : order.maker.emailAddress
                      : ""
                  }}<br />
                  {{ order.maker ? order.maker.deliveryAddress : "" }}
                </address>
              </div>
              <div class="col-md-6 text-right">
                <address>
                  <strong>Order Details:</strong><br />
                  Order Id: {{ order.orderNumber }}<br />
                  Order Date: {{ formatDate(order.created) }}
                </address>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="panel panel-default">
              <div class="panel-heading">
                <h3 class="panel-title">
                  <strong>Order summary</strong>
                </h3>
              </div>
              <div class="panel-body">
                <div class="table-responsive">
                  <table class="table table-condensed">
                    <thead>
                      <tr>
                        <td style="width: 45%">
                          <strong>Item Description</strong>
                        </td>
                        <td
                          style="width: 20%; text-align: center"
                          class="text-center"
                        >
                          <strong>Price (NGN)</strong>
                        </td>
                        <td
                          style="width: 15%; text-align: center"
                          class="text-center"
                        >
                          <strong>Quantity</strong>
                        </td>
                        <td
                          style="width: 20%; text-align: right"
                          class="text-right"
                        >
                          <strong>Amount (NGN)</strong>
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in order.details" :key="index">
                        <td>{{ item.code }} - {{ item.description }}</td>
                        <td
                          class="text-center font-weight-light"
                          style="text-align: center"
                        >
                          &#8358; {{ formatMoney(item.unitPrice) }}
                        </td>
                        <td
                          class="text-center font-weight-light"
                          style="text-align: center"
                        >
                          {{ item.quantity }}
                        </td>
                        <td
                          class="text-right font-weight-light"
                          style="text-align: right"
                        >
                          &#8358;
                          {{ formatMoney(item.quantity * item.unitPrice) }}
                        </td>
                      </tr>

                      <tr>
                        <td colspan="3">&nbsp;</td>
                      </tr>

                      <tr>
                        <td class="thick-line"></td>
                        <td class="thick-line"></td>
                        <td
                          class="thick-line text-center"
                          style="text-align: center"
                        >
                          <strong>Subtotal</strong>
                        </td>
                        <td
                          class="thick-line text-right"
                          style="text-align: right"
                        >
                          &#8358; {{ formatMoney(order.subtotal) }}
                        </td>
                      </tr>
                      <tr>
                        <td class="no-line"></td>
                        <td class="no-line"></td>
                        <td
                          class="no-line text-center"
                          style="text-align: center"
                        >
                          <strong>Discount</strong>
                        </td>
                        <td
                          class="no-line text-right"
                          style="text-align: right"
                        >
                          &#8358; {{ formatMoney(order.discount) }}
                        </td>
                      </tr>
                      <tr>
                        <td class="no-line"></td>
                        <td class="no-line"></td>
                        <td
                          class="no-line text-center"
                          style="text-align: center"
                        >
                          <strong>Grand Total</strong>
                        </td>
                        <td
                          class="no-line text-right"
                          style="text-align: right"
                        >
                          &#8358; {{ formatMoney(order.total) }}
                        </td>
                      </tr>
                      <tr>
                        <td class="no-line"></td>
                        <td class="no-line"></td>
                        <td
                          class="no-line text-center"
                          style="text-align: center"
                        >
                          <strong>Outstanding Balance</strong>
                        </td>
                        <td
                          class="no-line text-right"
                          style="text-align: right"
                        >
                          &#8358;
                          {{ formatMoney(order.total - totalPayment) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <h3><strong>Payment Details</strong></h3>
                </div>
                <div class="table-responsive">
                  <table class="table table-condensed" style="width: 100%">
                    <thead>
                      <tr>
                        <td style="width: 34%">
                          <strong>Amount Paid (NGN)</strong>
                        </td>
                        <td
                          style="width: 33%; text-align: center"
                          class="text-center"
                        >
                          <strong>Type</strong>
                        </td>
                        <td
                          style="width: 33%; text-align: right"
                          class="text-right"
                        >
                          <strong>Date Of Payment</strong>
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in order.paymentHistory"
                        :key="index"
                      >
                        <td>
                          &#8358;
                          {{
                            item.paidAmount < 0
                              ? formatMoney(item.paidAmount * -1)
                              : formatMoney(item.paidAmount)
                          }}
                        </td>
                        <td style="text-align: center" class="text-center">
                          {{ item.paidAmount < 0 ? "Refund" : "Payment" }}
                        </td>
                        <td style="text-align: right" class="text-right">
                          {{ formatDate(item.created) }}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">&nbsp;</td>
                      </tr>
                      <tr>
                        <td class="no-line"></td>
                        <td
                          style="text-align: center"
                          class="no-line text-center"
                        >
                          <strong>Total</strong>
                        </td>
                        <td
                          style="text-align: right"
                          class="no-line text-right"
                        >
                          &#8358; {{ formatMoney(totalPayment) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                </div>
                <hr />
                <div class="w-full">
                  <div class="text-center">
                    Receipt generated from weKurnect
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade colored-header colored-header-primary"
      id="mod-add-item"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header modal-header-colored">
            <h4 class="modal-title p-1"><b>Add Item</b></h4>
            <button
              class="close md-close"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row" v-if="!v_new_item.is_valid">
              <div class="col-12 col-sm-12 col-lg-12">
                <label
                  class="col-12 col-sm-12 text-sm-center alert alert-danger"
                  >{{ v_new_item.text }}</label
                >
              </div>
            </div>

            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right"
                >Product</label
              >
              <div class="col-12 col-sm-8 col-lg-8">
                <select
                  placeholder="Select an option"
                  class="form-control"
                  v-model="newItem.productId"
                >
                  <option
                    v-for="p in filteredProducts"
                    :key="p.id"
                    :value="p.id"
                  >
                    {{ p.name }} ({{ p.code }}) - N{{
                      formatMoney(p.retailPrice)
                    }}/{{ p.unit }}
                  </option>
                </select>
                <ul
                  v-if="v_new_item.productId"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right"
                >Quantity</label
              >
              <div class="col-12 col-sm-8 col-lg-8">
                <input
                  :class="[
                    'form-control',
                    { 'is-invalid': v_new_item.quantity },
                  ]"
                  type="number"
                  v-model="newItem.quantity"
                />
                <ul
                  v-if="v_new_item.quantity"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">Enter a number > 0.</li>
                </ul>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right"
                >Discount</label
              >
              <div class="col-12 col-sm-8 col-lg-8">
                <input
                  :class="[
                    'form-control',
                    { 'is-invalid': v_new_item.discount },
                  ]"
                  type="number"
                  step="0.01"
                  v-model="newItem.discount"
                />
                <ul
                  v-if="v_new_item.discount"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">Enter a number.</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="width: 100px"
              class="btn btn-secondary"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              style="width: 130px"
              :disabled="isBusyModal"
              class="btn btn-primary"
              type="button"
              @click.prevent="postAddItem"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Add</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade colored-header colored-header-primary"
      id="mod-edit-item"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header modal-header-colored">
            <h4 class="modal-title p-1"><b>Edit Item</b></h4>
            <button
              class="close md-close"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row" v-if="!v_edit_item.is_valid">
              <div class="col-12 col-sm-12 col-lg-12">
                <label
                  class="col-12 col-sm-12 text-sm-center alert alert-danger"
                  >{{ v_edit_item.text }}</label
                >
              </div>
            </div>

            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right"
                >Product</label
              >
              <div class="col-12 col-sm-8 col-lg-8">
                <select
                  placeholder="Select an option"
                  class="form-control"
                  v-model="editItem.productId"
                  disabled
                >
                  <option v-for="p in products" :key="p.id" :value="p.id">
                    {{ p.name }} ({{ p.code }}) - N{{
                      formatMoney(p.retailPrice)
                    }}/{{ p.unit }}
                  </option>
                </select>
                <ul
                  v-if="v_edit_item.productId"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right"
                >Quantity</label
              >
              <div class="col-12 col-sm-8 col-lg-8">
                <input
                  :class="[
                    'form-control',
                    { 'is-invalid': v_edit_item.quantity },
                  ]"
                  type="number"
                  v-model="editItem.quantity"
                />
                <ul
                  v-if="v_edit_item.quantity"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">Enter a number > 0.</li>
                </ul>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right"
                >Discount</label
              >
              <div class="col-12 col-sm-8 col-lg-8">
                <input
                  :class="[
                    'form-control',
                    { 'is-invalid': v_edit_item.discount },
                  ]"
                  type="number"
                  v-model="editItem.discount"
                />
                <ul
                  v-if="v_edit_item.discount"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">Enter a number.</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="width: 100px"
              class="btn btn-secondary"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              style="width: 130px"
              :disabled="isBusyModal"
              class="btn btn-primary"
              type="button"
              @click.prevent="postEditItem"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade colored-header colored-header-primary"
      id="mod-edit-order-discount"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header modal-header-colored">
            <h4 class="modal-title p-1"><b>Edit Order Discount</b></h4>
            <button
              class="close md-close"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <div class="col-12 col-sm-12 col-lg-12">
                <label
                  class="col-12 col-sm-12 text-sm-center alert alert-primary"
                >
                  Please note that discounts applied on individual products can
                  be modified.
                </label>
              </div>
            </div>

            <div class="form-group row" v-if="!v_edit_discount.is_valid">
              <div class="col-12 col-sm-12 col-lg-12">
                <label
                  class="col-12 col-sm-12 text-sm-center alert alert-danger"
                  >{{ v_edit_discount.text }}</label
                >
              </div>
            </div>

            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right"
                >Discount</label
              >
              <div class="col-12 col-sm-8 col-lg-8">
                <input
                  :class="[
                    'form-control',
                    { 'is-invalid': v_edit_item.discount },
                  ]"
                  step="0.01"
                  type="number"
                  v-model="editDiscount.discount"
                />
                <ul
                  v-if="v_edit_discount.discount"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">Enter a number.</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="width: 100px"
              class="btn btn-secondary"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              style="width: 130px"
              :disabled="isBusyModal"
              class="btn btn-primary"
              type="button"
              @click.prevent="postEditOrderDiscount"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      id="printingPos"
      style="display: flex; justify-content: center; width: 100%"
      v-show="false"
    >
      <div class="card-body bg-white text-dark">
        <div class="container" id="pos">
          <div class="row">
            <div class="col">
              <h3
                style="
                  text-align: center;
                  font-size: 8em;
                  font-weight: 1000;
                  color: black;
                "
              >
                {{ order.seller ? order.seller.name : "NA" }}
              </h3>
              <hr />
              <div style="text-align: center">
                <div style="font-size: 4.5em; font-weight: 1000">
                  <address>
                    <strong>Customer Details:</strong>
                    {{ order.maker ? order.maker.displayName : "" }}<br />
                    {{
                      order.maker
                        ? order.maker.phoneNumber
                          ? order.maker.phoneNumber
                          : order.maker.emailAddress
                        : ""
                    }}
                    {{ order.maker ? order.maker.deliveryAddress : "" }}
                  </address>
                </div>
              </div>
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <div style="font-size: 4em; font-weight: 1000; color: black">
                  <address>
                    <small><b>Date: </b>{{ formatDate(order.created) }}</small
                    ><br />
                    <small><b>RN: </b>{{ order.orderNumber }}</small>
                  </address>
                </div>
                <div style="font-size: 4em; font-weight: 1000; color: black">
                  <address>
                    <small>
                      <b> Order Id: </b>{{ order.orderNumber }}<br />
                      <b>Order Date:</b>
                      {{ formatDate(order.created) }}
                    </small>
                  </address>
                </div>
              </div>
            </div>
          </div>
          <div style="width: 100%">
            <h4 style="text-align: center">
              <strong style="font-size: 7em; font-weight: 1000"
                >Cash Receipt</strong
              >
            </h4>
            <table style="width: 100%; table-layout: fixed">
              <thead>
                <tr style="font-size: 6em; font-weight: 1000">
                  <th style="border-bottom: 5px solid black; width: 70%">
                    Item
                  </th>
                  <th style="border-bottom: 5px solid black; width: 30%">
                    U/Cost
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  style="font-size: 4em; font-weight: 1000; color: black"
                  v-for="(item, index) in order.details"
                  :key="index"
                >
                  <td style="text-align: start; width: 70%">
                    {{ item.description }}
                  </td>
                  <td style="text-align: start; width: 30%">
                    &#8358;
                    {{ formatMoney(item.unitPrice * item.quantity) }}
                  </td>
                </tr>
                <tr style="font-size: 4em; font-weight: 1000; color: black">
                  <td style="text-align: start; width: 70%">Discount</td>
                  <td style="text-align: start; width: 30%">
                    &#8358; {{ formatMoney(customDiscount) }}
                  </td>
                </tr>
                <tr style="font-size: 4em; font-weight: 1000; color: black">
                  <td style="text-align: start">Total</td>
                  <td style="text-align: start">
                    &#8358; {{ formatMoney(order.total) }}
                  </td>
                </tr>
                <tr style="font-size: 4em; font-weight: 1000; color: black">
                  <td style="text-align: start; width: 70%">
                    Total Amount paid
                  </td>
                  <td style="text-align: start; width: 30%">
                    &#8358;
                    {{ order.payment && formatMoney(order.payment.paidAmount) }}
                  </td>
                </tr>
                <tr style="font-size: 4em; font-weight: 1000; color: black">
                  <td style="text-align: start; width: 70%">Outstanding</td>
                  <td style="text-align: start; width: 30%">
                    &#8358; {{ formatMoney(order.total - totalPayment) }}
                  </td>
                </tr>
              </tbody>
            </table>
            <hr />
            <div class="row justify-content-end">
              <div class="col-9" style="font-size: 3.5em; font-weight: 800">
                <small> Receipt generated from weKurnect</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PaymentReceipt :order="order" :bank="userAccount" />
    <PaymentInvoice
      :order="order"
      :bank="userAccount"
      :defaultAccount="defaultAccount"
    />
    <PaymentPos :order="order" />
    <PosInvoice :order="order" />
  </section>
</template>

<script>
import moment from "moment";
import { helper } from "@/helper";
import ModalOrder from "./ModalOrder.vue";
import PaymentInvoice from "../Order/PaymentInvoice.vue";
import PaymentPos from "../Order/PaymentPos.vue";
import PaymentReceipt from "../Order/PaymentReceipt.vue";
import PosInvoice from "../Order/PosInvoice.vue";

export default {
  components: {
    ModalOrder,
    PaymentInvoice,
    PaymentPos,
    PaymentReceipt,
    PosInvoice,
  },
  props: [
    "orders",
    "hasPermission",
    "loading",
    "viewFulfillment",
    "viewCancel",
    "confirmDelete",
    "manageAddRecord",
    "systemSettings",
  ],
  data() {
    return {
      isModalVisible: false,
      activeTab: "order",
      order: {},
      modalName: "",
      isBusy: false,
      isBusyFull: false,
      isDraft: null,
      isDeletingDraft: false,
      order: {
        parent: {},
        seller: {},
        payment: {},
        paymentHistory: [],
        details: [],
      },

      sendInvoice: {
        sendViaEmail: false,
        sendViaSms: false,
      },

      sendReceipt: {
        sendViaEmail: false,
        sendViaSms: false,
      },

      isBusyModal: false,
      monnifyScriptUrl: process.env.VUE_APP_MONNIFY_SCRIPT_URL,
      newItem: {
        productId: null,
        quantity: null,
        discount: null,
      },

      editItem: {
        detailId: null,
        productId: null,
        quantity: null,
        discount: 0,
      },

      editDiscount: {
        discount: null,
      },

      v_new_item: {
        productId: false,
        quantity: false,
        discount: 0,
        is_valid: true,
        text: "",
      },

      v_edit_item: {
        productId: false,
        quantity: false,
        discount: 0,
        is_valid: true,
        text: "",
      },
      v_edit_discount: {
        discount: 0,
        is_valid: true,
        text: "",
      },

      products: [],
      filteredProducts: [],
      deleteId: "",
      isEdit: false,
      editDetails: {},
      retryOrderPayload: {},
      orderPaymentStatus: null,
      orderPaymentStatusMsg: "",
      userAccount: null,
      defaultAccount: {},
      productCount: 0,
      total: 0.0,
      actionsList: [
        {
          label: "Disposed",
          id: 0,
        },
        {
          label: "Received",
          id: 1,
        },
        {
          label: "Reversed",
          id: 2,
        },
      ],
      txFee: 0,
      totalFee: 0,
      orderID: "",
    };
  },

  created() {
    this.getDefaultAccount();
  },
  methods: {
    async getUserAccount() {
      await this.$http
        .get("/Accounts/getCurrent")
        .then(function(res) {
          this.userAccount = res.body;
        })
        .catch(function() {});
    },
    async getUserById(sellerId) {
      await this.$http
        .get(`/Accounts/getById/${sellerId}`)
        .then(function(res) {
          this.userAccount = res.body;
        })
        .catch(function() {});
    },
    async getDefaultAccount() {
      await this.$http
        .get("/PaymentChannels/default")
        .then(function(res) {
          this.defaultAccount = res.body;
        })
        .catch(function() {});
    },
    switchTab(tab) {
      this.activeTab = tab;
    },
    formatDate(date) {
      return moment(date).format("ll");
    },

    formatDateWithTime(date) {
      return moment(date).format("ll");
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    async details(o) {
      this.orderID = o;
      try {
        const response = await this.$http.get("/Orders/getById/" + o);
        const data = await response.json();
        this.order = data;
        const sellerId = response.body.sellerId;
        if (
          this.user.accountType === "Distributor" &&
          this.user.accountType == "Customer"
        ) {
          this.getUserById(sellerId);
        }
        this.order.parent.name;
        this.isBusy = false;
        this.isModalVisible = true;
        document.body.style.overflow = "hidden";
        this.activeTab = "order";
      } catch (err) {}
    },
    closeModal() {
      document.body.style.overflow = "auto";
      this.isModalVisible = false;
    },
    filteredMenuItems(o) {
      const menuItems = [
        {
          label: "View Details",
          action: () => this.details(o.id),
          visible: true,
        },
        {
          label: "Fulfill Order",
          action: () => this.viewFulfillment(o),
          visible:
            o.status === "Pending" ||
            o.status === "Confirmed" ||
            o.status === "markAsDelivered" ||
            o.status === "recallDelivery" ||
            (o.status === "Dispatched" &&
              this.hasPermission("Orders_Fulfill") &&
              o.totalAmountPaid < o.total),
        },
        {
          label: "Record Payment",
          action: () => this.manageAddRecord(o.id),
          visible:
            o.paymentStatus != "PAID" &&
            (o.status === "Fulfilled" ||
              o.status === "Pending" ||
              o.status === "Confirmed" ||
              o.status === "markAsDelivered" ||
              o.status === "recallDelivery") &&
            this.hasPermission("Orders_Update"),
        },
        {
          label: "Cancel Order",
          action: () => this.viewCancel(o),
          style: { color: "red" },
          visible:
            o.totalAmountPaid == 0 &&
            (o.status === "Pending" ||
              o.status === "Confirmed" ||
              (o.status === "recallDelivery" &&
                this.hasPermission("Orders_Fulfill"))),
        },
        {
          label: "Delete Order",
          action: () => this.confirmDelete(o.id),
          style: { color: "red" },
          visible:
            o.totalAmountPaid == 0 &&
            ["Pending", "recallDelivery", "Confirm"].includes(o.status) &&
            this.hasPermission("Orders_Delete"),
        },
        {
          label: "Accept Cancel",
          action: () => this.cancelRequest(o.id, "accepted"),
          style: { color: "red" },
          visible:
            this.hasPermission("Orders_Accept_Cancellation") &&
            o.status === "Cancelling",
        },
        {
          label: "Reject Cancel",
          action: () => this.cancelRequest(o.id, "rejected"),
          style: { color: "blue" },
          visible:
            this.hasPermission("Orders_Reject_Cancellation") &&
            o.status === "Cancelling",
        },
      ];
      return menuItems.filter((item) => item.visible);
    },
    printReceipt() {
      const prtHtml = document.getElementById("paymentReceipt").innerHTML;
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      const WinPrint = window.open("", "_blank", "");

      WinPrint.document.write(`<!DOCTYPE html>
	               <html>
	                 <head>
	                   ${stylesHtml}
	                   <style>
	                       @font-face{
	                       font-family:feather;
	                       src:url(../assets/fonts/feather/fonts/feather.eot?t=1525787366991);
	                       src:url(../assets/fonts/feather/fonts/feather.eot?t=1525787366991#iefix) format('embedded-opentype'),
	                       url(../assets/fonts/feather/fonts/feather.woff?t=1525787366991) format('woff'),
	                       url(../assets/fonts/feather/fonts/feather.ttf?t=1525787366991) format('truetype'),
	                       url(../assets/fonts/feather/fonts/feather.svg?t=1525787366991#feather) format('svg')
	                       }
	                       html *
	                       {
	                          font-family: Sans-Serif, Arial !important;
	                       }
	                   </style>
	                 </head>
	                 <body>
	                   ${prtHtml}
	                 </body>
	               </html>`);

      WinPrint.print();
    },

    posReceipt() {
      const btnPrint = document.getElementById("printingPosReceipt").innerHTML;
      const WinPrint = window.open("", "_blank", "");
      WinPrint.document.write(`<!DOCTYPE html>
	               <html>
	                 <head>
	                  <link  rel="stylesheet"  href="../assets/css/bootstrap.css" media='print,screen' />
	                 </head>
	                 <body>
	                   ${btnPrint}
	                 </body>
	               </html>`);
      WinPrint.print();
    },
    printPOSInvoice() {
      const btnPrint = document.getElementById("printingPosInvoice").innerHTML;
      const WinPrint = window.open("", "_blank", "");
      WinPrint.document.write(`<!DOCTYPE html>
	               <html>
	                 <head>
	                  <link  rel="stylesheet"  href="../assets/css/bootstrap.css" media='print,screen' />
	                 </head>
	                 <body>
	                   ${btnPrint}
	                 </body>
	               </html>`);
      WinPrint.print();
    },

    printA4Invoice() {
      const prtHtml = document.getElementById("paymentInvoice").innerHTML;
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      const WinPrint = window.open("", "_blank", "");

      WinPrint.document.write(`<!DOCTYPE html>
	               <html>
	                 <head>
	                   ${stylesHtml}
	                   <style>
	                       @font-face{
	                       font-family:feather;
	                       src:url(../assets/fonts/feather/fonts/feather.eot?t=1525787366991);
	                       src:url(../assets/fonts/feather/fonts/feather.eot?t=1525787366991#iefix) format('embedded-opentype'),
	                       url(../assets/fonts/feather/fonts/feather.woff?t=1525787366991) format('woff'),
	                       url(../assets/fonts/feather/fonts/feather.ttf?t=1525787366991) format('truetype'),
	                       url(../assets/fonts/feather/fonts/feather.svg?t=1525787366991#feather) format('svg')
	                       }
	                       html *
	                       {
	                          font-family: Sans-Serif, Arial !important;
	                       }
	                   </style>
	                 </head>
	                 <body>
	                   ${prtHtml}
	                 </body>
	               </html>`);

      WinPrint.print();
    },
    viewSendInvoice() {
      // this.closeModal();
      $("#mod-send-invoice").modal("show");
    },
    async sendInvoiceForOrder() {
      if (!this.sendInvoice.sendViaEmail && !this.sendInvoice.sendViaSms) {
        this.$toast.error("Please select at least one means of notification.", {
          icon: false,
          rtl: false,
        });
      } else {
        this.isBusyModal = true;
        this.isBusy = true;
        var data = {
          sendViaEmail: this.sendInvoice.sendViaEmail,
          sendViaSms: this.sendInvoice.sendViaSms,
          orderId: this.orderID,
        };
        await this.$http
          .post("/orders/sendInvoice", data)
          .then(function(res) {
            this.isBusyModal = false;
            if (res.ok) {
              this.$toast.success("Invoice has been sent successfully.", {
                icon: false,
                rtl: false,
              });
            }
          })
          .catch(function() {});
        this.isBusy = false;
        this.isBusyModal = false;
        $("#mod-send-invoice").modal("hide");
      }
    },
    viewSendReceipt() {
      // this.isModalVisible = false;
      $("#mod-send-receipt").modal("show");
    },
    async sendReceiptForOrder() {
      if (!this.sendReceipt.sendViaEmail && !this.sendReceipt.sendViaSms) {
        this.$toast.error("Please select at least one means of notification.", {
          icon: false,
          rtl: false,
        });
      } else {
        this.isBusyModal = true;
        this.isBusy = true;

        var id = this.$route.params.id;

        var data = {
          sendViaEmail: this.sendReceipt.sendViaEmail,
          sendViaSms: this.sendReceipt.sendViaSms,
          orderId: id,
        };

        await this.$http
          .post(`/Orders/sendReceipt`, data)
          .then(function(res) {
            this.isBusyModal = false;
            if (res.ok) {
              this.$toast.success("Receipt has been sent successfully.", {
                icon: false,
                rtl: false,
              });
            }
          })
          .catch(function() {});
        $("#mod-send-receipt").modal("hide");
        this.isBusy = false;
        this.isBusyModal = false;
      }
    },
  },
  computed: {
    receiverHasPhoneNumber: function() {
      return this.order.maker
        ? this.order.maker.phoneNumber
          ? false
          : true
        : true;
    },
    receiverHasEmail: function() {
      return this.order.maker
        ? this.order.maker.emailAddress
          ? false
          : true
        : true;
    },
    user: function() {
      return this.$store.state.currentUser;
    },
    totalPayment: function() {
      var myTotal = 0;

      if (this.order.paymentHistory) {
        for (var i = 0, len = this.order.paymentHistory.length; i < len; i++) {
          myTotal += this.order.paymentHistory[i].paidAmount;
        }
      }

      return myTotal;
    },
    customDiscount: function() {
      let customDiscount = 0;

      const totalDiscountOnProducts = this.order.details.reduce(
        (acc, item) => acc + item.discount,
        0
      );
      customDiscount = this.order.discount - totalDiscountOnProducts;

      return customDiscount.toFixed(2);
    },
  },
};
</script>
<style scoped>
.header {
  background: #ecf9ff !important;
}
.custom-checkbox {
  width: 24px;
  height: 18.9px;
  appearance: none;
  border: 1px solid #96a0b5;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  outline: none;
  transition: background-color 0.2s ease-in-out;
}
.custom-checkbox:checked {
  background-color: rgba(36, 99, 235, 0.5);
  border-color: rgba(36, 99, 235, 1);
}

.custom-checkbox:checked::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #2463eb;
  font-size: 14px;
}
</style>
